import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

history.contextAwarePush = (to) => {
    history.push(`${history.location.pathname.split('/').splice(0,3).join().replaceAll(',','/')}${to}`)
};

export default history;
